import { useEffect, useRef } from 'react';
/**
 * Clears the previewed spot when the user scrolls the spot list on desktop
 * @param previewedSpotId
 * @param clearPreview
 * @param enabled
 */
export const useClearPreviewOnDesktopScroll = ({ previewedSpotId, clearPreview, enabled, }) => {
    const isPointerInList = useRef(false);
    useEffect(() => {
        if (!enabled)
            return;
        const listWrapper = document.getElementById('SpotListWrapper');
        if (!listWrapper)
            return;
        const handlePointerEnter = () => {
            isPointerInList.current = true;
        };
        const handlePointerLeave = () => {
            isPointerInList.current = false;
        };
        const handleScrollIntent = () => {
            if (previewedSpotId && isPointerInList.current) {
                clearPreview();
            }
        };
        listWrapper.addEventListener('mouseenter', handlePointerEnter);
        listWrapper.addEventListener('mouseleave', handlePointerLeave);
        listWrapper.addEventListener('wheel', handleScrollIntent, {
            passive: true,
        });
        listWrapper.addEventListener('scroll', handleScrollIntent, {
            passive: true,
        });
        return () => {
            listWrapper.removeEventListener('mouseenter', handlePointerEnter);
            listWrapper.removeEventListener('mouseleave', handlePointerLeave);
            listWrapper.removeEventListener('wheel', handleScrollIntent);
            listWrapper.removeEventListener('scroll', handleScrollIntent);
        };
    }, [previewedSpotId, clearPreview, enabled]);
};
